import React from 'react';
import {Col, Panel, Row} from 'react-bootstrap';
import PropTypes from 'prop-types';
import Button from '../../common/button';

const NotificationFilter = ({
  onChange, doSearch, onSearch, searchValue = '', placeholder = 'Search...'
}) => (
  <Row>
    <Col md={12}>
      <Panel className="mg-tb-20">
        <Row>
          <Col lg={9} >
            <input
              className="form-control"
              onChange={onChange}
              onKeyPress={doSearch}
              placeholder={placeholder}
              value={searchValue}
            />
          </Col>
          <Col lg={3}>
            <Button onClick={onSearch}>Search</Button>
          </Col>
        </Row>
      </Panel>
    </Col>
  </Row>
);


NotificationFilter.propTypes = {
  searchValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default NotificationFilter;



// WEBPACK FOOTER //
// ./src/components/admin/notifications/notification-filter.jsx